import { basePath } from '../next.config'
import loggingService from './loggingService'

/**
 * @deprecated Any client-side calls should be converted to server-side calls in ./pages/api/musicapp/_services or
 * ported to ./client/index.ts if necessary
 */
export const addFavourite = async (id: number): Promise<boolean> => {
	let response: Response

	try {
		response = await fetch(`${basePath}/api/musicapp/favourites/${id}`, {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
			},
		})

		if (!response.ok) {
			throw new Error(response.status.toString())
		}

		return true
	} catch (error) {
		loggingService('Error adding a favourite', error, {
			errorType: 'Favourite',
			fetchUrl: response?.url,
			fetchStatus: response?.status,
		})
		return false
	}
}

/**
 * @deprecated Any client-side calls should be converted to server-side calls in ./pages/api/musicapp/_services or
 * ported to ./client/index.ts if necessary
 */
export const removeFavourite = async (id: number): Promise<boolean> => {
	let response: Response

	try {
		response = await fetch(`${basePath}/api/musicapp/favourites/${id}`, {
			method: 'DELETE',
			headers: {
				'Content-Type': 'application/json',
			},
		})

		if (!response.ok) {
			throw new Error(response.status.toString())
		}

		return true
	} catch (error) {
		loggingService('Error deleting a favourite', error, {
			errorType: 'Favourite',
			fetchUrl: response?.url,
			fetchStatus: response?.status,
		})
		return false
	}
}

/**
 * @deprecated Any client-side calls should be converted to server-side calls in ./pages/api/musicapp/_services or
 * ported to ./client/index.ts if necessary
 */
export const clearAll = async (): Promise<boolean> => {
	let response: Response

	try {
		response = await fetch(`${basePath}/api/musicapp/favourites/clearall`, {
			method: 'DELETE',
			headers: {
				'Content-Type': 'application/json',
			},
		})

		if (!response.ok) {
			throw new Error(response.status.toString())
		}

		return true
	} catch (error) {
		loggingService('Error removing all favourites', error, {
			errorType: 'Favourite',
			fetchUrl: response?.url,
			fetchStatus: response?.status,
		})
		return false
	}
}
